// 页面标题模块多语言配置
export const pageTitle = {
  'zh-CN': {
    dashboard: '仪表板',
    customerList: '客户列表',
    orderList: '订单列表',
    marketingList: '营销活动',
    financeList: '财务记录'
  },
  'zh-TW': {
    dashboard: '儀表板',
    customerList: '客戶列表',
    orderList: '訂單列表',
    marketingList: '營銷活動',
    financeList: '財務記錄'
  },
  'en': {
    dashboard: 'Dashboard',
    customerList: 'Customer List',
    orderList: 'Order List',
    marketingList: 'Marketing Activities',
    financeList: 'Financial Records'
  }
}; 